import { useTranslation } from "react-i18next";

function FullPageLoading() {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={t("common.loading")}
      className="flex h-dvh items-center justify-center"
    >
      <span className="border-muted border-t-foreground size-10 animate-spin rounded-full border-4" />
    </div>
  );
}

export default FullPageLoading;
